var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "el",
      staticClass: "pagination",
      class: { "text-center": _vm.paginationType === "loadMore" },
    },
    [
      _vm.paginationType === "infinite"
        ? _c("spinner")
        : _vm.paginationType === "page"
        ? _c("pagination-list", {
            attrs: { value: _vm.page, "max-pages": _vm.maxPages },
            on: { input: _vm.setPage },
          })
        : _vm.paginationType === "loadMore"
        ? [
            _c("p", [_vm._v(_vm._s(_vm.currentLoadMoreText))]),
            _vm._v(" "),
            _c("bar-loader", {
              attrs: { current: (_vm.viewed / _vm.totalCount) * 100 },
            }),
            _vm._v(" "),
            _vm.viewed !== _vm.totalCount
              ? _c("standard-button", {
                  attrs: { text: _vm.translations.search.showMore },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.setPage(_vm.page + 1)
                    },
                  },
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }